import { render, staticRenderFns } from "./WorkerSelector.vue?vue&type=template&id=3436a979&"
import script from "./WorkerSelector.vue?vue&type=script&lang=js&"
export * from "./WorkerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports